export default __webpack_public_path__ + "static/deeper-dive-ehe-eta-abd1508bb713cf797ec4db20e79176b6.png";